export default __webpack_public_path__ + "static/media/babstract.d01c6a18.jpg";